import {authDestination} from './authContinuation';

const key=id=>`pabs-remote-install:${id}`;
const pendingKey=client=>`pabs-remote-pending:${client}`;
const activeKey=client=>`pabs-remote-active:${client}`;
// Plain words are enough: the connector's own instructions and tool
// descriptions tell the agent to start with pabs_guidance initialization.
export const REMOTE_INIT_PROMPT='Use the Pabs connector to set up this project.';
export const REMOTE_WORK_GUIDANCE='Use the Pabs connector’s pabs_guidance with reference operating for meaningful product work and design_craft for interface or design-guideline work. Check alignment with this project’s saved goal and applicable design sources; use proportionate local checks for routine edits. Follow exact saved work and return consequential evidence or user answers to Pabs. Preserve human decisions. This is guidance for the builder, not an integration to add to the published app.';

// Signed-in setup request. An expired sign-in returns here after login.
export async function clientSetupRequest(path,options={},returnTo=`${window.location.pathname}${window.location.search}`) {
  const response=await fetch(`/api/client-setup/${path}`,{...options,credentials:'same-origin',headers:{'Content-Type':'application/json',Authorization:`Bearer ${localStorage.getItem('token')}`},...(options.body?{body:JSON.stringify(options.body)}:{})});
  if(response.status===401) {
    localStorage.removeItem('token');
    window.location.assign(authDestination('/login',returnTo));
    return null;
  }
  return response;
}

export function readRemoteInstallation(id) {
  try {
    const value=JSON.parse(sessionStorage.getItem(key(id)));
    return value?.id===id && value.origin===window.location.origin && /^[a-f0-9]{64}$/.test(value.secret) ? value:null;
  } catch {return null;}
}

// The link's secret lives only in this tab: never in project files or a URL.
export async function connectRemoteInstallation(client,planId=null) {
  // Reuse the identity for a retry of the same choice, so a lost response
  // can't leave a second approved link behind.
  const existing=readRemoteInstallation(sessionStorage.getItem(pendingKey(client)));
  let identity=existing && String(existing.plan_id || '')===String(planId || '') ? existing:null;
  if(!identity) {
    identity={id:crypto.randomUUID(),client_name:client,plan_id:planId,origin:window.location.origin,
      secret:Array.from(crypto.getRandomValues(new Uint8Array(32)),byte=>byte.toString(16).padStart(2,'0')).join('')};
    sessionStorage.setItem(key(identity.id),JSON.stringify(identity));
    sessionStorage.setItem(pendingKey(client),identity.id);
  }
  const response=await clientSetupRequest('remote',{method:'POST',body:{id:identity.id,client_name:client,secret:identity.secret,plan_id:planId}},`/brief?client=${client}`);
  if(!response) return null;
  const result=await response.json();
  if(!response.ok) throw new Error(result.error || 'Could not create the connection link. Try again.');
  sessionStorage.removeItem(pendingKey(client));
  sessionStorage.setItem(activeKey(client),identity.id);
  return {id:identity.id,status:result.status,plan_id:result.plan_id,project_label:result.project_label};
}

export function activeRemoteInstallation(client) {
  return readRemoteInstallation(sessionStorage.getItem(activeKey(client)));
}

export function forgetRemoteInstallation(id) {
  const value=readRemoteInstallation(id);
  sessionStorage.removeItem(key(id));
  if(!value) return;
  for(const slot of [pendingKey(value.client_name),activeKey(value.client_name)]) if(sessionStorage.getItem(slot)===id) sessionStorage.removeItem(slot);
}
